export const defaultOptions = {
  refetchOnWindowFocus: true,
  staleTime: 10 * 60 * 1000,
  gcTime: 180 * 60 * 1000,
} as const

export const liveOptions = {
  refetchOnWindowFocus: true,
  staleTime: 3 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
} as const
